import loadable from '@loadable/component';
import categoryIndexPageQuery from './query.graphql';

const CategoryIndex = loadable(() =>
  import(/* webpackChunkName: "category-index" */ './category-index')
);

CategoryIndex.graphQL = categoryIndexPageQuery;

export default CategoryIndex;
